<template>
  <v-container
    id="login"
    class="fill-height"
    tag="section"
  >
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card
          color="success"
          light
          max-width="100%"
          width="400"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">
                Login
              </h1>

              <v-btn
                v-for="(social, i) in socials"
                :key="i"
                :href="social.href"
                class="ma-1"
                icon
                rel="noopener"
                target="_blank"
              >
                <v-icon
                  v-text="social.icon"
                />
              </v-btn>
            </div>
          </template>

          <v-card-text class="text-center">
            <div class="text-center grey--text body-1 font-weight-light">
              Or Be Classical
            </div>

            <v-text-field
              v-model="username"
              color="secondary"
              label="Username..."
              prepend-icon="mdi-face"
              class="mt-10"
            />

            <v-text-field
              v-model="password"
              color="secondary"
              label="Password..."
              prepend-icon="mdi-lock-outline"
              class="mb-8"
            />

            <pages-btn
              large
              color=""
              depressed
              class="v-btn--text success--text"
              @click="login"
            >
              Let's Go
            </pages-btn>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>

  import { oidcSettings } from '../../config/oidc'
  import axios from 'axios'

  export default {
    name: 'PagesLogin',

    components: {
      PagesBtn: () => import('./components/Btn'),
    },

    data: () => ({
      username: '',

      password: '',

      socials: [
        {
          href: '#',
          icon: 'mdi-facebook-box',
        },
        {
          href: '#',
          icon: 'mdi-twitter',
        },
        {
          href: '#',
          icon: 'mdi-github-box',
        },
      ],
    }),

    methods: {
      login: function () {
        const payload = {
          Username: this.username,
          Password: this.password,
        }

        const endpoint = oidcSettings.authority + '/connect/authorize'

        axios.post(endpoint, payload)
          .then(response => {
            alert(JSON.stringify(response))
          })
      },
    },
  }
</script>
